import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import ArrowBack from '@mui/icons-material/ArrowBack';

import { Typography } from '@mui/material';
import { GameConfig } from '../../../Config.model';
import { useConfig } from '../../../ConfigContext';

import { Breadcrumb, BreadcrumbPath } from '../../../_shared/breadcrumb/Breadcrumb';
import { Tooltip } from '../../../_shared/tooltip/Tooltip';
import title from '../../../_assets/mym-logo-white.webp';
import thumbnail from '../../../_assets/thumbnail/mym.webp';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { RegistrationStatus } from '../../Account.model';
import { Modal } from '../../../_shared/modal/Modal';
import { ClaimSteamComponent } from './ClaimSteam';
import { GameTrailer } from '../common/Game-trailer';
// import { ReferralComponent } from '../../../_shared/referral/ReferralComponent';
import { post } from '../../../utils/Request';
// import { ShareCode } from '../../../referral/ReferralCode.model';
import { ShareReferralLinkComponent } from '../../../_shared/referral/ShareReferralLinkComponent';
import { useSnackbar } from '../../../snackbar/SnackbarContext';
import { Steam } from '../../providers/steam/Steam';
import { GameAccount } from '../../../authentication/Authentication.model';
import { GameIds, Stores } from '../MyGames.model';
import { GameNewsletters } from '../common/game-newsletters/Game-newsletters';

export function MymGame(): JSX.Element {
  const { t } = useTranslation(['mym', 'translation']);
  const history = useHistory();
  const location = useLocation<{ showClaimModal: boolean }>();
  const config = useConfig();
  const auth = useAuth();
  const match = useRouteMatch();
  const snackbar = useSnackbar();

  const [mymConfig, setMymConfig] = useState<GameConfig>(null);
  const [userRegistrationStatus, setUserRegistrationStatus] = useState<RegistrationStatus>(null);
  const [showClaimModal, setShowClaimModal] = useState<boolean>(location.state?.showClaimModal);
  const [showReferralModal, setShowReferralModal] = useState<boolean>(false);
  const [showlinkModal, setShowLinkModal] = useState<boolean>(false);

  const currentPreReg = auth.user?.preRegistrations[mymConfig?.id]?.[mymConfig?.preRegistration.id];
  const NDA_DISABLED = true;

  const getProviderAccount = (providerName: string): GameAccount => {
    const pa = auth.user.accounts.find((account) => account.type === providerName);
    return (pa);
  };

  const breadcrumb: BreadcrumbPath[] = [
    {
      key: 'button.my-account',
      path: '/account/my-account',
    },
    {
      key: 'Meet Your Maker',
      path: '',
    },
  ];

  const back = (): void => {
    history.push('/');
  };

  const handleClaim = async (): Promise<void> => {
    const preRegId = mymConfig.preRegistration.id;
    const gameId = mymConfig.id;
    try {
      await post(`${config.clientConfig.host}/players/me/games/${gameId}/pre-registrations/${preRegId}/claim`, {
        data: {
          provider: Stores.STEAM,
          isNdaAccepted: true,
        },
      });

      auth.getPlayer();
      setShowClaimModal(true);
    } catch (e) {
      // TODO: Get error translations
      snackbar.addErrorMessage('UnknownError');
    }
  };

  const closeClaimModal = (): void => {
    setShowClaimModal(false);
  };
  const getUserPreRegistrations = (): void => {
    if (mymConfig) {
      if (!Object.keys(mymConfig.preRegistration).length) {
        setUserRegistrationStatus(RegistrationStatus.UNAVAILABLE);
        return;
      }
      const preRegId = mymConfig.preRegistration.id;
      const userGamePreRegistration = auth.user.preRegistrations.mym;
      if (!userGamePreRegistration?.[preRegId]?.status) {
        setUserRegistrationStatus(RegistrationStatus.UNREGISTERED);
      } else {
        setUserRegistrationStatus(userGamePreRegistration[preRegId].status as RegistrationStatus);
      }
    }
  };

  const handleCloseLinkModal = (): void => {
    if (getProviderAccount(Stores.STEAM)) {
      handleClaim();
    }
    setShowLinkModal(false);
  };

  const handlePreregClick = (): void => {
    if (userRegistrationStatus === RegistrationStatus.GRANTED) {
      setShowClaimModal(true);
    }
    if (userRegistrationStatus === RegistrationStatus.SELECTED) {
      if (NDA_DISABLED) {
        if (getProviderAccount(Stores.STEAM)) {
          handleClaim();
        } else {
          setShowLinkModal(true);
        }
      } else {
        history.push(`${match.url}/preregistration/claim`);
      }
    }
  };

  // const generateReferralLink = async (): Promise<ShareCode> => {
  //   const { host } = config.clientConfig;
  //   const preRegId = mymConfig.preRegistration.id;
  //   const gameId = mymConfig.id;
  //   // const preRegId = mymConfig.preRegistration.id;
  //   const { eventId } = mymConfig.preRegistration.referral;
  //   return post(`${host}/players/me/games/${gameId}/pre-registrations/${preRegId}/generate-refer-link/${eventId}`);
  // };

  // const getReferralLink = async (): Promise<ShareCode> => {
  //   const { eventId } = mymConfig.preRegistration.referral;
  //   return get<ShareCode>(`${config.clientConfig.host}/sharecodes/eventId/${eventId}`);
  // };

  useEffect(() => {
    const co = config.serverConfig.gamesConfig?.find((gamecConfig) => gamecConfig.id === 'mym');
    if (!co) {
      history.push('/');
    } else {
      setMymConfig(co);
    }

    if (location.state?.showClaimModal != null) {
      window.history.replaceState({}, document.title);
    }
  }, []);

  useEffect(() => {
    getUserPreRegistrations();
  }, [mymConfig]);

  const renderRegistrationStatusSection = (): JSX.Element => {
    if (userRegistrationStatus === RegistrationStatus.UNREGISTERED) {
      return (
        <>
          <div className='description'>
            {t('translation:account.my-account.registration.registerPlaytestDescription')}
          </div>
          <button
            key='mym-unregistered-btn'
            type='button'
            data-cy='register-playtest-btn'
            className='btn btn-primary-game btn-block mx-auto'
            onClick={() => history.push(`${match.url}/preregistration/survey`)}
          >
            {t('translation:account.my-account.registration.registerForPlaytest')}
          </button>
        </>
      );
    }
    return (
      <>
        <div className='item-status' data-cy={`game-mym-${userRegistrationStatus}`}>
          <div>{t(`translation:account.my-account.registration.${userRegistrationStatus}`)}</div>
          <div className={`status ${userRegistrationStatus}`} />
        </div>
        <button
          disabled={(userRegistrationStatus !== RegistrationStatus.SELECTED
            && userRegistrationStatus !== RegistrationStatus.GRANTED)}
          style={{ pointerEvents: userRegistrationStatus === RegistrationStatus.REGISTERED
            || userRegistrationStatus === RegistrationStatus.SELECTED_NO_CLAIM
            || userRegistrationStatus === RegistrationStatus.REFERRED ? 'none' : 'auto' }}
          type='button'
          key='status-button'
          data-cy='registration-status-button'
          className='btn btn-primary-game btn-block mx-auto'
          onClick={handlePreregClick}
        >
          {userRegistrationStatus === RegistrationStatus.GRANTED
            ? t('translation:account.my-account.registration.seeSteam')
            : t('translation:account.my-account.registration.claimGame')}
        </button>
      </>
    );
  };

  return (
    <>
      <div className='game-container our-game-container'>
        <img className='game-thumbnail' src={thumbnail} alt='Meet Your Maker Thumbnail' />
        <div className='banner mym-banner' data-cy='mym-banner'>
          <button type='button' className='btn btn-secondary back-btn' onClick={back}>
            <ArrowBack className='icon' />
            {t('translation:button.back')}
          </button>
          <Breadcrumb paths={breadcrumb} />
          <img className='title mym' src={title} alt='title mym' height={120} />
          {userRegistrationStatus !== RegistrationStatus.UNAVAILABLE
            && (
              <>
                <div data-cy='mym-playtest-registration'>
                  <div className='subtitle'>
                    <h3 className='register-playtest-title'>{t('translation:account.my-account.closedPlaytest')}</h3>
                    <Tooltip id='tooltip.registerPlaytest' message='tooltip.registerPlaytest' />
                  </div>
                  <div className='items-container text-center'>
                    {userRegistrationStatus === RegistrationStatus.UNREGISTERED ? (
                      <h4>{t('translation:account.my-account.registration.registration')}</h4>
                    ) : (
                      <h4>{t('translation:account.my-account.registration.registrationStatus')}</h4>
                    )}

                    {renderRegistrationStatusSection()}
                    <button
                      type='button'
                      data-cy='referral-btn'
                      className='btn btn-secondary full-width btn-refer'
                      onClick={() => setShowReferralModal(true)}
                    >
                      {t('translation:account.my-account.referrals.referBtn')}
                    </button>
                  </div>
                </div>
                {/* The newsletter section will be revised and we will decide either keep it or remove it */}
                {/* {userRegistrationStatus !== RegistrationStatus.UNREGISTERED && (
                  <div data-cy='mym-newsletter'>
                    <div className='subtitle'>
                      <h3 className='register-playtest-title'>{t('translation:account.my-account.newsletter')}</h3>
                    </div>
                    <div className='items-container text-center newsletter-container'>
                      <NewsLetterForm
                        hasWarning={userRegistrationStatus !== RegistrationStatus.GRANTED}
                        gameId={GameIds.MYM}
                      />
                    </div>
                  </div>
                )} */}
              </>
            )}
          <GameNewsletters
            title={t('mym:newsletters.title')}
            sectionTitle={t('mym:newsletters.sectionTitle')}
            description={t('mym:newsletters.description')}
            gameId={GameIds.MYM}
            subscribeButtonText={t('mym:newsletters.subscriptionButton')}
            subscriptionConfirmation={t('mym:newsletters.subscriptionConfirmed')}
            tos={t('mym:newsletters.tos')}
            subscribedMessages={['specialEvents', 'salesAndSpecialOffers', 'gameNews']}

          />
          <GameTrailer
            websiteUrl='https://meetyourmakergame.com/'
            storesUrls={{
              steam: 'https://store.steampowered.com/app/1194810/Meet_Your_Maker/',
              playstation: 'https://store.playstation.com/en-ca/concept/10004068',
            }}
            youtubeUrl='https://www.youtube.com/embed/BQh5L8wlkG0'
            isReleased={false}
            hasMultiplePlatforms
          />
        </div>
      </div>
      {mymConfig?.preRegistration.id && (
        <>
          <Modal
            show={showClaimModal}
            isInfoModal
            close={closeClaimModal}
            textConfirm={t('translation:button.confirm')}
            textClose={t('translation:common.cancel')}
            maxWidth={800}
          >
            <div className='form-light'>
              <ClaimSteamComponent
                accessCode={currentPreReg?.providerKey?.accessCode}
                steamKey={currentPreReg?.providerKey?.key}
                preRegId={mymConfig?.preRegistration.id}
                gameId='mym'
              />
            </div>
          </Modal>
          <Modal
            show={showlinkModal}
            close={handleCloseLinkModal}
            textClose={t('translation:button.close')}
            maxWidth={800}
          >
            <div className='form-light'>
              <Typography variant='h5' className='mb-3'>
                {t('translation:preregistration.claim.providerLink')}
              </Typography>
              <Steam />
            </div>
          </Modal>
          <Modal show={showReferralModal} isInfoModal close={() => setShowReferralModal(false)} maxWidth={625}>
            {/* Keeping the referal code in case we need it in the future */}
            {/* {userRegistrationStatus === RegistrationStatus.GRANTED
              && (mymConfig.preRegistration.referral.eventId && mymConfig.preRegistration.referral.referralUrl)
              && (!currentPreReg.referredBy || mymConfig.preRegistration.referral.chaining)
              && mymConfig.preRegistration.referral.limit > 0 ? (
                <ReferralComponent
                  eventId={mymConfig?.preRegistration.referral.eventId}
                  generateCode={generateReferralLink}
                  getCode={getReferralLink}
                />
              ) : (
                <ShareReferralLinkComponent
                  eventName='mym-closedBeta'
                  shareLink='/mym/beta'
                />
              )} */}
            <ShareReferralLinkComponent
              eventName='mym-closedBeta'
              shareLink='/mym/beta'
            />
          </Modal>
        </>
      )}
    </>
  );
}
